import { HTMLProps } from 'react';
import { logoUrl } from '../SiteLogo';
import { SocialLinks } from '../../../../components';
import { contactDetails, formatPhone } from '@utils';
import { useTranslation } from 'react-i18next';

export const FooterContactInfo = (props: HTMLProps<HTMLDivElement>) => {
  const { t } = useTranslation();

  return (
    <div {...props}>
      <div className='footer-widget footer-about-widget'>
        <div className='footer-logo'>
          <img src={logoUrl} alt='Logo' />
        </div>
        <div className='footer-address'>
          <ul>
            <li>
              <div className='footer-address-icon'>
                <i className='icon-placeholder'></i>
              </div>
              <div className='footer-address-info'>
                <a href='https://maps.app.goo.gl/V7ryJ3ivnpmzfFSQA'>
                  {t('footer.address')}
                </a>
              </div>
            </li>
            <li>
              <div className='footer-address-icon'>
                <i className='icon-call'></i>
              </div>
              <div className='footer-address-info'>
                <p>
                  <a href={'tel:' + contactDetails.phone}>
                    {formatPhone(contactDetails.phone)}
                  </a>
                </p>
              </div>
            </li>
            <li>
              <div className='footer-address-icon'>
                <i className='icon-mail'></i>
              </div>
              <div className='footer-address-info'>
                <p>
                  <a href={'mailto:' + contactDetails.mail}>
                    {contactDetails.mail}
                  </a>
                </p>
              </div>
            </li>
          </ul>
        </div>
        <SocialLinks className='ltn__social-media mt-20' />
      </div>
    </div>
  );
};
